import { tDGovService } from "@/utils/request";
import { wgs84togcj02 } from "@/utils/coord-transform";

// 地名模糊搜索
export const tdtSearchPlace = (params) =>
  tDGovService.get("/v2/search", {
    params: params,
  });

// 地名编译为坐标,坐标编译成地名
export const tdtGeocoder = (params) =>
  tDGovService.get("/geocoder", {
    params: params,
  });

// 地名编译为坐标,坐标编译成地名
export const tdtAdministrative = (params) =>
  tDGovService.get("/administrative", {
    params: params,
  });

/**
 * @description: 地名模糊搜索
 * @param {*} keyword 搜索的地名
 * @param {*} key 天地图key
 * @return {*} 数据 http://lbs.tianditu.gov.cn/server/search2.html
 * 
  const addressRet = await tdtFuzzySearch('合肥置地广场', '93cf92b607754b4f9581fc316863c6a9');
  console.log(JSON.stringify(addressRet.pois));
  if (addressRet && addressRet.pois && addressRet.pois.length) {
    console.log(addressRet.pois.map(item => item.name + item.lonlat.split(',')).join('|'));
  } 
*/
export const tdtFuzzySearch = (keyword, option = {}) => {
  let defaultOption = {
    keyWord: keyword,
    level: 12,
    mapBound: "72.004,0.8293,137.8347,55.8271", // 中国范围内搜索
    queryType: 7,
    start: 0,
    count: 10,
  };
  defaultOption = Object.assign(defaultOption, option);
  return tdtSearchPlace({
    postStr: JSON.stringify(defaultOption),
    type: "query",
  });
};

/**
   * @description: 地名编译为坐标
   * @param {*} keyword 地名
   * @param {*} key 天地图key
   * @return {*} 数据 http://lbs.tianditu.gov.cn/server/search2.html
   * const coordRet = await tdtAddressToCoord('合肥置地广场', '93cf92b607754b4f9581fc316863c6a9');
    if (coordRet && coordRet.location && coordRet.location.lon && coordRet.location.lat) {
      console.log(coordRet.location.lon, coordRet.location.lat);
    }
*/
export const tdtAddressToCoord = (keyword, option = {}) => {
  let defaultOption = {
    keyWord: keyword,
  };
  defaultOption = Object.assign(defaultOption, option);
  return tdtGeocoder({
    ds: JSON.stringify(defaultOption),
  });
};

/**
   * @description: 坐标逆编译为地址
   * @param {Array<number>} coord - 查询坐标
   * 	@param {number} coord[0] - 纬度 lat 注意坐标系是wgs84，或国家2000
   * 	@param {number} coord[1] - 经度 lng 注意坐标系是wgs84，或国家2000
   * @param {*} key - 天地图key
   * @return {*}
   * const addressRet = await tdtCoordToAddress([31.806462, 117.220351], '93cf92b607754b4f9581fc316863c6a9');
    if (addressRet && addressRet.result && addressRet.result.formatted_address) {
      console.log(addressRet.result.formatted_address);
    }
*/
export const tdtCoordToAddress = (coord = [], option = {}) => {
  let defaultOption = { lat: coord[0], lon: coord[1], ver: 1 };
  defaultOption = Object.assign(defaultOption, option);
  return tdtGeocoder({
    postStr: JSON.stringify(defaultOption),
    type: "geocode",
  });
};

/**
 * @description: 获取行政区划相关内容
 * @param {*} key 天地图key
 * @return {*} 数据 http://lbs.tianditu.gov.cn/server/administrative.html
 * await tdtGetAdministrativeDivision({"searchWord":"蜀山区"});
 */
export const tdtGetAdministrativeDivision = (option = {}) => {
  let defaultOption = {
    searchWord: "北京",
    searchType: "1",
    needSubInfo: "false",
    needAll: "false",
    needPolygon: "false",
    needPre: "false",
  };
  defaultOption = Object.assign(defaultOption, option);
  return tdtAdministrative({
    postStr: JSON.stringify(defaultOption),
  });
};

/**
 * @description: 获取行政区划信息 坐标转换为 GCJ-02
 * @param {*} key 天地图key
 * @return {*} 数据 http://lbs.tianditu.gov.cn/server/administrative.html
 * await tdtGetAdministrativeCoord("蜀山区");
 */
export const tdtGetAdministrativeCoord = async (administrativeName) => {
  let center;
  let govInfo = await tdtGetAdministrativeDivision({
    searchWord: administrativeName,
  });
  if (
    govInfo &&
    govInfo.data &&
    govInfo.data.length &&
    govInfo.data[0].lat &&
    govInfo.data[0].lnt
  ) {
    center = [govInfo.data[0].lnt, govInfo.data[0].lat];
    center = wgs84togcj02(...center);
    return center;
  }
  return;
};
